import TimelineHeader from "./TimelineHeader";
import Timeline_ProfileBuilding from "./Timeline_ProfileBuilding";
import TimelineCard from "./TimelineBottomCard";

const OtherCareerInterest = () => {
  return (
    <div>
      {" "}
      <div className="">
        <TimelineHeader />
        <Timeline_ProfileBuilding />
        <TimelineCard />
      </div>
    </div>
  );
};

export default OtherCareerInterest;
